export default __webpack_public_path__ + "static/media/blindsLivingroomTop.8fa17e9f.gif";